let CURRENT_ENV: string;
if (location.host.match(/192\.168/) || location.host.match(/localhost/)) {
  CURRENT_ENV = 'DEV';
} else if (location.host.match(/staging/)) {
  CURRENT_ENV = 'STAGING';
} else {
  CURRENT_ENV = 'PRODUCTION';
}

console.log('current environment:', CURRENT_ENV);

const Constants = {
  /** current environment */
  ENV: CURRENT_ENV,

  /** possible environments */
  DEV: 'DEV',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION',
  VERSION: 1,
  FUNCTION_MEMO: 1,
  FUNCTION_WIKI: 2,
  FUNCTION_NOTE: 3,
  FUNCTION_BOARD: 4,
  FUNCTION_MEMO_NOTIFICATION: 5,
  REPORT_INTERIM: 1,
  REPORT_FINAL: 2,

  DEV_SERVER: 'http://localhost:15010',
  // DEV_SERVER: "https://mmapi.daikokudrug.com",

  STAGING_SERVER: 'https://staging.api.daikokudrug.com',
  PRODUCTION_SERVER: 'https://mmapi.daikokudrug.com',

  DEV_SOCKET: 'http://localhost:15011',
  STAGING_SOCKET: 'https://staging.api.daikokudrug.com:3000',
  PRODUCTION_SOCKET: 'https://mmapi.daikokudrug.com:3000'
};

export default Constants;



// WEBPACK FOOTER //
// ./src/common/Constants.ts